import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MY_ORGANIZATION, ROLE_DESCRIPTION, USER, USER_NEW } from '../../enums/TYPES';
import { removeRefreshToken, removeToken } from '../../helpers/localStorage';
import { ROLES, RolesByTitle } from '../../enums/ROLES';
import { API_ROUTES } from '../../enums/API_ROUTES';
import { getAllRoles } from '../../api/usersApi';
import { STATUS } from '../../enums/ENUMS';
import { PATHS } from '../../enums/PATHS';

export type TUser = {
  role: ROLES | null;
  currentUser: USER | null;
  authChecked: boolean;
  myOrganization: MY_ORGANIZATION;
  status: STATUS;
  allRoles: ROLE_DESCRIPTION[];
  userList: any[]; //USER_NEW[] | USER[];
};

const initialState: TUser = {
  role: null,
  currentUser: null,
  authChecked: false,
  myOrganization: <MY_ORGANIZATION>{},
  status: STATUS.IDLE,
  allRoles: [],
  userList: [],
};

export const getAllRolesThunk = createAsyncThunk(API_ROUTES.ROLES, async () => {
  const roles = await getAllRoles();
  return roles;
});

export const userSlice = createSlice({
  name: 'userRole',
  initialState,
  reducers: {
    saveUser: (state, action: PayloadAction<USER>) => {
      state.currentUser = action.payload;
      state.authChecked = true;

      // @ts-ignore
      state.role = RolesByTitle[action.payload.role.title];
    },
    setAuthChecked: (state, action: PayloadAction<boolean>) => {
      state.authChecked = action.payload;
    },
    updateUserList: (state, action) => {
      state.userList = action.payload;
    },
    removeCurrentUser: (state) => {
      if (state.currentUser) {
        window.location.pathname = PATHS.MAIN.path;
      }
      state.currentUser = null;
      state.role = null;
      state.authChecked = true;
      removeToken();
      removeRefreshToken();
    },
    saveMyOrganization: (state, action: PayloadAction<MY_ORGANIZATION>) => {
      state.myOrganization = action.payload;
    },
    updateMyOrganizationUsage: (
      state,
      action: PayloadAction<{
        organizationId: number;
        storage_limit: number;
        storage_usage: number;
        hours_limit: number;
        hours_limit_used: number;
        download_hours_limit: number;
        download_hours_limit_used: number;
      }>,
    ) => {
      if (String(state.myOrganization.id) !== String(action.payload.organizationId)) return;
      state.myOrganization.storage_limit = action.payload.storage_limit;
      state.myOrganization.storage_usage = action.payload.storage_usage;
      state.myOrganization.hours_limit = action.payload.hours_limit;
      state.myOrganization.hours_limit_used = action.payload.hours_limit_used;
      state.myOrganization.download_hours_limit = action.payload.download_hours_limit;
      state.myOrganization.download_hours_limit_used = action.payload.download_hours_limit_used;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllRolesThunk.pending, (state) => {
        state.status = STATUS.LOADING;
      })
      .addCase(getAllRolesThunk.fulfilled, (state, action: PayloadAction<ROLE_DESCRIPTION[]>) => {
        state.status = STATUS.IDLE;
        state.allRoles = action.payload;
      })
      .addCase(getAllRolesThunk.rejected, (state) => {
        state.status = STATUS.FAILED;
      });
  },
});

export const {
  saveUser,
  setAuthChecked,
  removeCurrentUser,
  saveMyOrganization,
  updateMyOrganizationUsage,
  updateUserList,
} = userSlice.actions;

export default userSlice.reducer;
